import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'space',
    // TODO: update these details
    description: 'Space App Description.',
    icon: 'space',
    name: 'Space',
    scenarioVariables: [],
    sessionVariables: [],
    supportsFunctionalityConfiguration: true,
    supportsScenarios: true,
  },
  type: core.quiver.Resource.Type.App,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.App>
